// Settings Constants
// Purpose: Defines keys/defaults used by the persisted settings subsystem. Scope: Centralizes stable identifiers and fallback values for settings storage.
export const SETTINGS_COOKIE = 'roverSettings';
export const SETTINGS_STORAGE_KEY = 'roverSettings';
